import { compose } from 'recompose';
import { source } from 'react-aim';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { isEUNonBusinessStore } from 'ggApp/modules/store';

import { Item } from './Item';

const enhance = compose(
    connect(
        createStructuredSelector({
            isEUNonBusinessStore,
        }),
    ),
    source({
        mouseEnter: ({ toggleSubCategories, categoryIndex }) => {
            toggleSubCategories(categoryIndex);
        },
    }),
);

export default enhance(Item);
